function debug_dump(ob){
	var i = '';
	for(var ele in ob){
		var typ = typeof(ob[ele]);
		i += (' ['+ele+'] is a/n '+typ+('function'!=typ?' = '+ob[ele]:'')+'\n');
	}
	alert(i);
}
function force_primary(mox, o){	// the default mox.has_one forced select function, used by Inventory Order form.
	o.checked = true;
	if(o.up('tr')){
		var tr = o.up('tr');
		tr.addClassName('preferred');
	} 
}
function get_rightside(mox){
	mox.form.insert($('the_rest_of_the_form').hide());
	mox.form.insert($('billing_container').hide());
	mox.form.insert($('shipping_top_container').hide());
	if($('tag_container'))
		mox.form.insert($('tag_container').hide());
	if ($('new_order_attachment'))
		mox.form.insert($('new_order_attachment').hide());
	// DEV-13063: posted LAST on purpose. PHP silently drops the tail of a request that
	// exceeds max_input_vars (a big order plus a duplicated folder can post thousands of
	// fields), and the sidebar appended above - order name, status - IS that tail.
	// controllers/orders/quote.php checks for this field before anything else, so a
	// truncated save fails with "too much data" instead of "you must include a name",
	// and never saves an order minus its truncated products.
	// DEV-13740: one id per page load. A second click (after the 30s busy guard lets go) or a
	// browser re-POST sends the same id, and quote.php skips the duplicate save. Inserted before
	// data_end so data_end stays last.
	if (!mox.form.down('input[name="save_nonce"]'))
		mox.form.insert(new Element('input', {'type': 'hidden', 'name': 'save_nonce', 'value': Date.now().toString(36) + Math.random().toString(36).slice(2)}));
	if (!mox.form.down('input[name="data_end"]'))
		mox.form.insert(new Element('input', {'type': 'hidden', 'name': 'data_end', 'value': '1'}));
}
// DEV-13740: a page restored from the back/forward cache is a new editing session - drop its old
// save_nonce so the next Save is not mistaken for a duplicate of the save already made.
window.addEventListener('pageshow', function (e) {
	if (!e.persisted) return;
	var stale = document.querySelectorAll('input[name="save_nonce"]');
	for (var i = 0; i < stale.length; i++) stale[i].parentNode.removeChild(stale[i]);
});
function job_tags_trick(){
	$('jobs').insert($('tags'));
}
function noAjax(mox) {
	mox.ajax = false;
}

async function validatePhoneNumberElements(){
	var pageValidationObject = new ValidatePage();
	var validationSection = am.$('#phoneset');
	pageValidationObject.update_page_to_section(validationSection);
	return await pageValidationObject.validate();
}

async function validateSmsPhoneNumber() {
	var smsPageValidationObject = new ValidatePage();
	var smsAnnouncementSection = am.$('#contact_personal_announcement_section');
	smsPageValidationObject.update_page_to_section(smsAnnouncementSection);
	return await smsPageValidationObject.validate();
}

isContactForm = () => window.location.href.include('/accounts/contacts/edit/');

submitHandler = async (ob, extra_validation, shouldSubmitAndEditNext) => {
	try {
		if (shouldSubmitAndEditNext && ob) {
			ob.insert(new Element('input', {'type': 'hidden', 'name': 'save_and_next', 'value': '1'}));
		}
		const canLoginChecked = am.$('#can_login') && am.$('#can_login')[0] && am.$('#can_login')[0].checked;

		var smsFieldSeen = am.$('#tasks_send_sms_assigned')[0] && (am.$('#tasks_send_sms_assigned')[0].checked ||
			am.$('#tasks_send_sms')[0].checked ||
			am.$('#annonucements_send_sms')[0].checked);

		if (isContactForm() && smsFieldSeen) {
			const [contactPhoneNumbersValidated, contactSmsPhoneNumberValidated] = await Promise
				.all([validatePhoneNumberElements(), validateSmsPhoneNumber()]);

			if (contactPhoneNumbersValidated && contactSmsPhoneNumberValidated) {
				return MoxForm.Go(ob, extra_validation, false, (canLoginChecked ? '': 'user_account'));
			}
		} else {
			const contactPhoneNumbersValidated = await validatePhoneNumberElements();

			if (contactPhoneNumbersValidated) {
				return MoxForm.Go(ob, extra_validation,false, (canLoginChecked ? '': 'user_account'));
			}
		}
	} catch (error) {
		console.error(error);
		return;
	}
}

function MoxForm(id, ajax){
	if (ajax)
		this.ajax = true;
	this.form = $(id);
	this.failed = false;
	this.prevent_submit = false;
	this.in_flight = false; // DEV-12585: true only while a submit is actually running
	this.form.select('input.default,textarea.default,input.no_default,textarea.no_default').each(function(def){
		MoxForm.defaultify(def);
	});
}
MoxForm.prevent_submit = false;
MoxForm.now = false;
MoxForm.Go = function (ob, extra_validation, prevent_submit = false, elementToIgnore = ''){
	var rel = ob.getAttribute('rel');
	if(rel && !rel.blank()){
		if(!$('submit_action')){
			$(ob).up().insert(new Element('input', {'id':'submit_action','name':'submit_action', 'type':'hidden'}));
		}
		$('submit_action').value = rel;
	}
	var clicked = $(ob);
	ob = $(ob).tagName.toLowerCase()=='form'?$(ob):$(ob).up('form');
	if(!ob) return false;	// if you have no form to submit, fail
	if(!ob.mox) ob.mox = new MoxForm(ob);
	ob.mox.prevent_submit = prevent_submit;
	// remember the button that fired the submit so the ajax path can show a
	// busy state on it (feedback for slow requests + double-submit guard)
	ob.mox.trigger = (clicked && clicked.tagName && clicked.tagName.toLowerCase() != 'form') ? clicked : null;
	return ob.mox.submit(extra_validation, elementToIgnore);
}
MoxForm.default_focus = function(e){
	var element = e.element?e.element():$(e);
	element.removeClassName('default');
	if(element.value == element.getAttribute('default_value'))
		element.value = '';
}
MoxForm.default_blur = function(e){
	var element = e.element?e.element():$(e);
	if(element.value.blank() || element.value == element.getAttribute('default_value')){
	//if(!cur2num(element.value) || element.value == element.getAttribute('default_value')){
		element.value = element.getAttribute('default_value');
		element.addClassName('default');
	}
	return false;
}
MoxForm.defaultify = function(id, default_value, submit){
	var element = $(id);
	if(!element) return;
	if(!element.getAttribute('default_value'))
		element.setAttribute('default_value', default_value || element.value);
	element.observe('focus',MoxForm.default_focus);
	element.observe('blur',MoxForm.default_blur);
//	if(!submit){
//		element.up('form').observe('modal:validate', function(e){
//			if(element.value == default_value && $(element).hasClassName('default')) {
//				element.value = '';
//			}
//		});
//		element.up('form').observe('modal:un_validate', function(e){
//			if(element.value == '' && element.hasClassName('default')) {
//				element.value = default_value;
//			}
//		});
//	}
}
MoxForm.clear_defaults = function(mox){
	mox.form.select('.default').each(function(ele){ ele.value = ''; });
}

MoxForm.re_defaultify = function(mox_form)
{
	mox_form.select('input.default,textarea.default,input.no_default,textarea.no_default').each(function(def)
	{
		if(!def.value && def.getAttribute('default_value'))
				def.value = def.getAttribute('default_value');
	});
}

MoxForm.prototype = {
	seen : function(ele){
		var theparent = $(ele);
		if(theparent && theparent != document){
			// hidden data becomes cleared data.
			if(!theparent.visible()) return false;
			theparent = theparent.up();
		}
		return true;
	},
	submit : function(extra_validation, elementToIgnore = ''){
		// DEV-12585: one submit per form at a time. Users spam submit on slow pages and each
		// duplicate request holds 3-4 MySQL connections for its whole life (Site::init() opens
		// them before index.php even reaches session_start()), so a handful of duplicates
		// exhausts max_connections and everyone on the instance gets "Too many connections".
		// The flag lives on the FORM, not on the triggering button: the button-level guard
		// below only exists when a button was passed to MoxForm.Go(), and 82 of the inline
		// call sites pass the form instead, leaving them completely unguarded.
		if (this.in_flight) return false;
		let elementsToIgnore = [];
		if (elementToIgnore) {
			elementsToIgnore = Array.from(am.$('#' + elementToIgnore).find('input, select, checkbox'))
				.map(element => element.id);
		}
		this.reset();
		var elements = this.form.select('input,select,textarea'), instance = this, pass = [];
		try{
			// don't validate classless elements
			elements.findAll(function(e){ return !e.className.blank(); })
				.filter(element =>  !elementsToIgnore.include(element.id))
				.each(function(ele){
				if(ele.hasClassName('required'))
					instance.require(ele);
				else if (ele.hasClassName('required-if-visible') && !!( ele.offsetWidth || ele.offsetHeight || ele.getClientRects().length ))
					instance.require(ele);
				else
					instance.validate(true,ele);
				if(ele.hasClassName('validate-password'))
					pass.push(ele);
				// if it's blank, don't validate except 'required'
				if(!$F(ele) || typeof($F(ele))=='object' || $F(ele).blank()) return;
				if(ele.hasClassName('validate-six-long')){
					instance.validate(
						$F(ele).length >= 6
						,ele
						,get_language_translation('LANG_MUST_BE_AT_LEAST_6_CHARS_LONG') + "."
					);
				}
				/********special characters****************************/
				if(ele.hasClassName('special-characters')){
					instance.validate(
						$F(ele).match(/^[A-Za-z0-9#!.]+$|\w{1,}[@][\w\-]{1,}([.]([\w\-]{1,})){1,3}$/)
						,ele
						,get_language_translation('LANG_NO_SPECIAL_CHARS_OR_SPACES') + "."
					);
				}
				/*****************************************************/
				if(ele.hasClassName('validate-ten-long')){
					instance.validate(
						$F(ele).length >= 10
						,ele
						,get_language_translation('LANG_MUST_BE_AT_LEAST_TEN_CHARS_LONG') + "."
					);
				}
				if(ele.hasClassName('validate-email'))
					instance.validate(
						$F(ele).match(/\w{1,}[@][\w\-]{1,}([.]([\w\-]{1,})){1,3}$/)
						,ele
						,get_language_translation('LANG_PLEASE_ENTER_A_VALID_EMAIL_ADDRESS_FOR_EXAMPLE') + " <b>billg@microsoft.com</b> ."
					);
				if(ele.hasClassName('validate-url'))
					instance.validate(
						$F(ele).match(/^(https?:\/\/)?(([A-Z0-9][A-Z0-9_-]*)(\.[A-Z0-9][A-Z0-9_-]*)+)(:(\d+))?\/?/i)
						,ele
						,get_language_translation('LANG_PLEASE_ENTER_A_VALID_URL') + '.'
					);
				if(ele.hasClassName('validate-phone'))
					instance.validate(
						$F(ele).match(/^(\s*[\+]?\s*1\s*[\.-]?)?\s*(\d{3}|\(\s*\d{3}\s*\))\s*[\.-]?\s*\d{3}\s*[\.-]?\s*\d{4}((\s|[\.-]){1}\s*[\.-]?\s*([extnsioEXTENSIO\.\:]{1,9}?\s*[\.-]?)?\d{1,7})?$/) ||
						$F(ele).match(/\(?((\+|00)?\(?[1-9]{2}\s*?|0)[1-9]\)?( ?[0-9]){8}$/)
						,ele
						,get_language_translation('LANG_LABEL_PHONE_NUMBER_INVALID')
					);
				if(ele.hasClassName('validate-zip'))
					instance.validate(
						PostalCodeValidator.validate(PostalCodeValidator.findCountryIsoFor(ele) || 'US', $F(ele)).valid
						,ele
						,get_language_translation('LANG_PLEASE_ENTER_A_VALID_5_OR_9_DIGIT_ZIP_CODE_IN_THIS_FIELD') + '.'
					);
				if(ele.hasClassName('validate-zipc')) {
					var zipcIso = PostalCodeValidator.findCountryIsoFor(ele);
					instance.validate(
						zipcIso
							? PostalCodeValidator.validate(zipcIso, $F(ele)).valid
							: (PostalCodeValidator.patterns.US.regex.test($F(ele)) || PostalCodeValidator.patterns.CA.regex.test($F(ele)))
						,ele
						,get_language_translation('LANG_PLEASE_ENTER_A_VALID_5_OR_9_DIGIT_US_ZIP_OR_6_CHAR_CAD_ZIP_CODE_IN_THIS_FIELD') + '.'
					);
				}
				if(ele.hasClassName('validate-zip-aus'))
					instance.validate(
						PostalCodeValidator.validate(PostalCodeValidator.findCountryIsoFor(ele) || 'AU', $F(ele)).valid
						,ele
						,get_language_translation('LANG_EXCEPTION_YOUR_ZIPCODE_IS_NOT_VALID') + '.'
					);
				if(ele.hasClassName('format_date'))
					instance.date(ele.id, undefined, true);
			});
			if(pass.length>1){
				var where = pass[1];
				pass.each(function(p,i){
					pass[i] = $(p).hasClassName('default')?'':$F(p);
				});
				this.validate(
					pass[0] == pass[1]
					,where
					,get_language_translation('LANG_PASSWORDS_DONT_MATCH') + "."
				);
			}
			if(typeof(extra_validation)=='function') extra_validation(this);
			if (this.failed) {
				// Validation advice renders next to the failing field, which can be
				// far above the submit button — announce the block at the click site
				// too, so a failed submit never reads as "nothing happened"
				var _errMsg = get_language_translation('LANG_ERRORS_ON_THIS_PAGE') || 'errors on this page';
				show_snackbar({ message: _errMsg.charAt(0).toUpperCase() + _errMsg.slice(1) + '.', type: 'danger' });
			}
			if(!this.failed && !this.prevent_submit) {
				if (this.ajax) {
						// Busy feedback: spinner on the triggering button while the request is
						// in flight; also guards against double-submits on slow responses.
						var trigger = this.trigger || null;
						if (trigger && trigger.classList) {
							if (trigger.classList.contains('is-busy'))
								return false;
							trigger.classList.add('is-busy');
						}
						// Latched here, past validation and past prevent_submit, so a rejected submit
						// never leaves the form dead.
						var mox = this;
						mox.in_flight = true;
						var stallGuard = null;
						var clearBusy = function() {
							if (stallGuard) clearTimeout(stallGuard);
							mox.in_flight = false;
							if (trigger && trigger.classList) trigger.classList.remove('is-busy');
						};
						// Bounded, like the 30s/10s/5s resets initReportDoubleClickPrevention uses: an
						// Ajax.Request that never settles (no onSuccess, no onFailure, no onException)
						// would otherwise leave this form permanently unsubmittable with nothing on
						// screen to explain why.
						stallGuard = setTimeout(clearBusy, 30000);
						var failBusy = function() {
							clearBusy();
							// raw English matches this endpoint's own success payload ("Task
							// added."); swap to a translation key once one ships in broker
							show_snackbar({ message: 'Save failed. Please try again.', type: 'danger' });
						};
						new Ajax.Request(this.form.action, {
							method:'post',
							parameters: this.form.serialize(true),
							onSuccess: function(ret) {
								clearBusy();
								var json = ret.responseText.evalJSON();
								if (json.msg) {
									show_snackbar({ message: json.msg });
									formSubmitted = false;
									if (window.Modalbox)
										window.Modalbox.hide();
								}
							},
							onFailure: function(ret) { failBusy(); },
							onException: function(req, e) { failBusy(); }
						});
				}
				else{
					// full-page submit: same busy feedback while the navigation runs
					if (this.trigger && this.trigger.classList)
						this.trigger.classList.add('is-busy');
					// The flag normally dies with the navigation. If the navigation is cancelled or
					// stalls, release it on the same 30s safety timer initReportDoubleClickPrevention
					// uses, so a form can never be permanently unusable (DEV-12475 was a bricked
					// button; this must not repeat that).
					var stalled = this;
					stalled.in_flight = true;
					setTimeout(function () {
						stalled.in_flight = false;
						if (stalled.trigger && stalled.trigger.classList) stalled.trigger.classList.remove('is-busy');
					}, 30000);
					// set window.onbeforeunload to null to remove the Alert
					window.onbeforeunload = null;
					
					// this protects against hidden untemplatized templates within the form. TODO: It shouldn't be necessary.
					$(this.form).select('[id*="~id~"]').each(function(a){
						if(a.remove) Element.remove(a);
					});
					
					this.form.submit();
				}
			}
			return false;
		} catch(e){
			try {
				const {is_admin} = get_user_info();
				if (is_admin) {
					console.error(e);
				}
			} catch (_) {
			}
			show_snackbar({ message: get_language_translation('LANG_MSG_ERROR_IN_VALIDATION_SCRIPT') + ": " + e.message, type: 'danger' });
			/*ERROR*/
			console.log(e.message);
			console.log((new Error()).stack);
			//if(typeof(extra_validation)=='function') extra_validation.toString());
			return false;
		}
	},
	reset : function(){ this.failed = false; },
	// cond = 		Set an expression you want to evaluate to true on success and false on failure.
	// elem = 		The element or elements to target: can be a string, a prototype element, or an array of either
	// 				If elem is an array, the last element will populate to repeat_errors, if it exists
	// no_wipe = 	Set to true to not clear error messages.
	// no_message = Set to true to not show error message just border the input that is missing
	validate : function(cond, elem, error_message, no_wipe, success_message, no_message){
		var elems = [];
        if (typeof (elem) === 'object' && typeof elem.innerHTML !== 'string') {
            elem.each(function (el) {
                if ($(el)) {
                    elems.push($(el));
                }
            });
        } else if ($(elem)) {
            elems.push($(elem));
        }
		elems.each(function(el,idx) {
			var advice_id = '_' + el.identify();
			if (cond) {
				if (!no_wipe) {
					if ($(advice_id)) GUI.remove_div($(advice_id));
					if($(advice_id+'_2')) GUI.remove_div($(advice_id+'_2'));
				}
				if (success_message) {
					if(!$(advice_id)) {
						var target = el.up('.row') ? el.up('.row') : el;
						if(target.hasClassName('cb2') || (target.tagName == 'INPUT' && target.up('label.am-checkbox'))) // cb2 = legacy checkbox; label.am-checkbox = M3 checkbox (DEV-12310)
							target = target.up('label');

						GUI.success_message(target, advice_id, success_message);
					}
					else
						$(advice_id).update(success_message).removeClassName('validation-advice').addClassName('success');
				}
				el.removeClassName('validation-failed').stopObserving('blur');
			}
			else {
				if(!$(advice_id)){
					var target = el.up('.row') ? el.up('.row') : el;
					if(target.hasClassName('cb2') || (target.tagName == 'INPUT' && target.up('label.am-checkbox'))){ // cb2 = legacy checkbox; label.am-checkbox = M3 checkbox (DEV-12310)
						if(advice_id && advice_id == '_')
							advice_id = `${advice_id}${el.id}`;

						GUI.error_message(target,advice_id,error_message);
					}
					if(!no_message)
						GUI.error_message(target,advice_id,error_message);
				}
				else
					$(advice_id).update(error_message).removeClassName('success').addClassName('validation-advice');

				if (!this.failed && idx == 0) {
					$(el).scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
					/**
					 * I comment this out because it gives the focus to the element,
					 * but then it removes the error message because of the blur event declared below.
					 *
					 * This happens when something request the focus before the user interacts with the element, ex:
					 * when the user tries to submit the form and a modal is shown, the modal has the focus and the input lost the focus.
					 *
					 * Also, this doesn't make sense because `elems` is an array and cannot add focus to every element in it.
					 * */
					// $(el).focus();
				}
				el.addClassName('validation-failed').observe('blur',this.clearError.bind(this));
			}
		}.bind(this));
		if (!cond && $('repeat_errors') && elems) {
			let omit = false;
			const el = elems.pop();
			if (el) {
				omit = el.classList.contains('omit-from-repeat') ?? true; // handles non addition of modal input validation on order pages where repeat_errors div exists
				if(omit)
					return;

				var advice_id = '_' + el.identify();
				if ($(advice_id + '_2'))
					$(advice_id + '_2').update(error_message);
				else
					$('repeat_errors').insert(new Element('div', {'id': advice_id + '_2'}).update(error_message)).show();
			}
		}
		this.failed = this.failed || !cond;
		return !cond;
	},
	clearError : function(ev) {
		var el = ev.findElement();
		var advice_id = '_' + el.identify();
		if ($(advice_id)) GUI.remove_div($(advice_id));
		if($(advice_id+'_2')) GUI.remove_div($(advice_id+'_2'));
		el.removeClassName('validation-failed').stopObserving('blur');
	},
	require : function(elem, error_message, no_wipe){
		elem = $(elem);
		var no_message = elem.className.includes('no-message');
		if (!elem)
			return;
		error_message = error_message || ('select'==elem.tagName.toLowerCase()?get_language_translation('LANG_MSG_PLEASE_MAKE_A_SELECTION')+'.':get_language_translation('LANG_ERR_COMPLETE_ABOVE')+'.');

		return this.validate((typeof($F(elem))=='object' && $F(elem) != null) || (!elem.disabled && !elem.hasClassName('default') && !($F(elem) == null || $F(elem).blank())), elem, error_message, no_wipe, undefined ,no_message);
	},
	groups : function(match, cols, parent, min_cols, extra_validation){
		parent = $(parent);
		var list = parent.select(match), count = list.length, instance = this;
		parent = $(parent);
		list.each(function(o){
			var uid = o.id.match(/\d+/);
			if(uid){
				uid = uid.shift();
				count -= instance.group(cols,uid,o.id);
			}
		});
		if(extra_validation) count += extra_validation(instance);
		this.validate(count >= min_cols, parent, get_language_translation('LANG_YOU_MUST_INCLUDE_AT_LEAST') + " "+min_cols+" row"+(min_cols==1?'':'s')+'.');
	},	
	group : function(fields, unique_id, parent, error_message){
		parent = $(parent);
		var failed_fields = 0, instance = this, at_least_one = [];
		fields.each(function(field,i){
			if(typeof(field)=='object'){
				var a = field.join()+unique_id; 
				at_least_one[a] = false;
				field.each(function(item){
					var id = item+unique_id;
					if($(id) && !$F(id).blank() && !$(id).hasClassName('default'))
						at_least_one[a] = true;
				});
				if(!at_least_one[a]) failed_fields++;
			} else {
				var id = field+unique_id;
				if(!($(id) && !$F(id).blank())) failed_fields++;
			} 
		});
		if(failed_fields == fields.length){
			GUI.remove_div(parent);
			return 1;
		} else {
			fields.each(function(field){
				if(typeof(field)=='object'){
					field.each(function(item){
						var a = field.join()+unique_id;
						instance.validate(at_least_one[a],item+unique_id,(error_message||get_language_translation('LANG_ONE_OF_THESE_IS_REQUIRED') + "."));
					});
				} else {
					var id = field+unique_id;
					instance.require(id,error_message);
				} 
			});
		}
		return 0;
	},
	has_one : function(match, force_one, errbox, err){
		const list = this.form.select(match);
		const bool = list.pluck('checked').some(function (o) {
			return o === true
		});

		if(!list){
			if(force_one) force_one(this);
			this.failed = true;
		} else if(!force_one || list.length > 1){
			if (!errbox && list)
				errbox = list.pop();
			if (!err)
				err = "Required";
			this.validate(bool, errbox, err);
		} else if(force_one && !bool){
			force_one(this, list[0]);
		}
	},	
	date : function(id, after, allow_ever){
		var o = $(id+'_parsed');
		if(o.innerHTML=='?' || (o.innerHTML.blank() && o.hasClassName('default')) || ($(id+'_sql').value.blank() && !o.innerHTML == 'ever')){
			return this.validate(false, o, get_language_translation('LANG_PLEASE_RE_ENTER_A_VALID_DATE_TIME') + ".");
		} else if(after !== undefined && o.innerHTML != 'ever' && o.hasClassName('default')){
			var now = new Date(); now.setHours(0); now.setMinutes(0); now.setSeconds(0);
			after = after || now;
			return this.validate(new Date(Date.parse(o.innerHTML)) > after, o, get_language_translation('LANG_TIME_TRAVEL_ERROR_TOO_SOON') + ".");
		}
		return this.validate(o.innerHTML != 'ever' || allow_ever, o, get_language_translation('LANG_THE_DATE_EVER_IS_NOT_ALLOWED_HERE') + ".");
	}
};
